import BusinessQuiz from "../entities/valueObjects/businessQuiz";

export default class BusinessQuizDTO {
  static fromJson(json: any): BusinessQuiz {
    return new BusinessQuiz(
      json.cnpj,
      json.razaoSocial,
      json.cnae,
      json.companyType,
      json.lastThreeMonthsRevenue,
      json.cardsRevenue,
      json.currentAcquirer,
      json.hasSpecialCheck,
      json.hasGuaranteedAccount,
      json.hasOtherLoans,
      json.hasDebt,
      json.debtValue,
      json.debitRate,
      json.debitRateAtSight,
      json.creditRateAtSight,
      json.creditRateInstallments,
      json.creditRateInstallmentsTwo,
      json.specialCheckValue,
      json.guaranteedAccountValue,
      json.otherLoansValue
    );

    /* constructor(
        public cnpj: string = "",
        public companyType: string = "",
        public hasSpecialCheck: boolean = false,
        public hasGuaranteedAccount: boolean = false,
        public hasOtherLoans: boolean = false,
        public debtValue: Currency = new Currency(),
        public debitRate: number = 0,
        public debitRateAtSight: number | null = null,
        public creditRateAtSight: number | null = null,
        public creditRateInstallments: number | null = null,
        public creditRateInstallmentsTwo: number | null = null,
    ) {} */
  }

  static toJson(businessQuiz: BusinessQuiz): any {
    console.log(
      "BusinessQuizDTO.toJson - businessQuiz recebido:",
      businessQuiz
    );
    const result = {
      cnpj: businessQuiz.cnpj,
      companyType: businessQuiz.companyType,
      lastThreeMonthsRevenue: businessQuiz.lastThreeMonthsRevenue,
      cardsRevenue: businessQuiz.cardsRevenue,
      currentAcquirer: businessQuiz.currentAcquirer,
      hasSpecialCheck: businessQuiz.hasSpecialCheck,
      hasGuaranteedAccount: businessQuiz.hasGuaranteedAccount,
      hasOtherLoans: businessQuiz.hasOtherLoans,
      hasDebt: businessQuiz.hasDebt,
      debtValue: businessQuiz.debtValue,
      debitRate: businessQuiz.debitRate,
      debitRateAtSight: businessQuiz.debitRateAtSight,
      creditRateAtSight: businessQuiz.creditRateAtSight,
      creditRateInstallments: businessQuiz.creditRateInstallments,
      creditRateInstallmentsTwo: businessQuiz.creditRateInstallmentsTwo,
      specialCheckValue: businessQuiz.specialCheckValue,
      guaranteedAccountValue: businessQuiz.guaranteedAccountValue,
      otherLoansValue: businessQuiz.otherLoansValue,
      razaoSocial: businessQuiz.razaoSocial,
      cnae: businessQuiz.cnae,
    };
    console.log("BusinessQuizDTO.toJson - resultado:", result);
    return result;
  }
}
